import { roleUserOptionsByRoleKey } from '@/api/system/user'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(roleUserOptionsByRoleKey)
